import React, { useState } from 'react';
import { Box, IconButton, Modal, Typography } from '@mui/material';
export const PrivacyModal = () => {
  const [open, setOpen] = useState(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        sx={{
          "& :focus-visible": {
            outline: "none"
          }
        }}
      >
          <Box
            width={{
              xs: '90%',
              sm: '80%',
              md: '60%',
              lg: '50%',
            }}
            style={{
              maxHeight: 'calc(85vh - 40px)', // Limit height to viewport
              display: 'flex',
              flexDirection: 'column', // Stack content and button vertically
              backgroundColor: 'white', // Background color of the modal
              marginTop: '60px',
              borderRadius: '5px',
              position: 'absolute',
            }}
          >
            <IconButton
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 0,
                top: 0,
                padding: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                },
                "&:before": {
                  "-webkitFontSmoothing": "auto",
                  content: "'X'",
                  color: "#ffffff",
                  padding: "8px 12px",
                  fontSize: "12px",
                  fontWeight: "normal",
                  fontStyle: "normal",
                  fontFamily: "Roboto Condensed",
                  background: "linear-gradient(to right, #ffffff 50%, #000000 50%)",
                  backgroundSize: "200% 100%",
                  backgroundPosition: "right bottom",
                  borderRadius: 0,
                  transition: "all .1s ease",
                },
                "&:hover:before": {
                  color: "#000000",
                  backgroundPosition: "left bottom",
                }
              }}
            />
            <Box
              style={{
                overflowY: 'auto', // Allow scrolling within this box
                flexGrow: 1, // Allows the content box to grow and fill available space
              }}
              sx={{
                marginTop: "30px",
                p: { xs: "15px 35px 35px 25px", md: "15px 65px 35px 45px" }
              }}
            >
            <Box sx={{textAlign: 'center'}}>
              <Typography id="modal-modal-title" variant="h2" component="h2">
                Privacy and Security Notice
              </Typography>
            </Box>
            <ul>
              <li><strong>Authority:</strong> The Air Force may collect personally identifiable information (PII) such as name and email address authorized by 10 U.S. Code § 9013, under the provisions of the Privacy Act of 1974 section 3(e)(1).</li>
              <li><strong>Purpose:</strong> Information is collected to verify your eligibility for an AFPC Secure account and to open/complete personnel actions request made by the user.</li>
              <li><strong>Routine Use:</strong> For site management, information is collected for analytical and statistical purposes. This government computer system uses software programs to create summary statistics, which are used for such purposes as assessing what information is of most and least interest, determining the technical design specifications, and identifying system performance or problem areas.</li>
              <li><strong>Disclosure:</strong> Voluntary; however, your interactions with this system is not anonymous. By using this system you are consenting to the monitoring of your activity. Raw data logs will only be used to identify individual users and their usage habits for authorized law enforcement investigations or national security purposes. These logs are used for no other purposes and are scheduled for regular destruction in accordance with Air Force Web-RIMS RDS.</li>
              <li><strong>System of Records Notice:</strong> Defense Civilian Human Resource Management System (DCHRMS), DHRA 23 DoD. (January 28, 2020; 85 FR 4949).</li>
            </ul>
            </Box>
          </Box>
      </Modal>
    </>
  );
};